import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
// @ts-ignore
import Carousel from '@r1-frontend/ui-react/deprecated/carousel';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';
import { BreakPointsMFirst } from '~/src/constants/breakpoints';

import { Container } from '~/src/features/yandex-landing/styled';

export const ContainerAlisaCarousel = styled(Container)`
    width: calc(100% - 180px);
    max-width: 1400px;
    box-sizing: content-box;

    @media (max-width: ${breakPoints.desktop}) {
        padding: 0 71px;
        width: calc(100% - 142px);
    }

    @media (max-width: ${breakPoints.sDesktop}) {
        width: calc(100% - 126px);
        padding: 0 63px;
    }

    @media (max-width: ${breakPoints.tablet}) {
        width: calc(100% - 44px);
        max-width: 1362px;
        padding: 0;
    }

    @media (max-width: ${breakPoints.mobile}) {
        width: calc(100% - 16px);
        max-width: 304px;
        padding-left: 16px;
    }
`;

export const AlisaCarouselTitle = styled.div`
    text-align: center;
    ${FONTS.H2};
    margin-top: 64px;
    margin-bottom: 32px;

    @media (max-width: ${breakPoints.desktop}) {
        ${FONTS.H3};
    }

    @media (max-width: ${breakPoints.mobile}) {
        white-space: pre;
        text-align: center;
        justify-content: left;
    }
`;

export const AlisaCarousel = styled(Carousel)`
    gap: 60px;
`;

export const AlisaCarouselWrapper = styled.div`
    cursor: default;
    justify-content: center;

    @media (max-width: ${breakPoints.mobile}) {
      height: 725px;
      flex-direction: column;
      justify-content: flex-start;
    }
`;

export const MainBlockWrapper = styled.div<{ background: string }>`
    width: calc(100% - 39px);
    height: 244px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    background-color: ${props => props.background ?? 'initial'};
    justify-content: space-between;

    @media (max-width: ${breakPoints.desktop}) {
        width: calc(100% - 35px);
    }

    @media (max-width: ${breakPoints.sDesktop}) {
        width: calc(100% - 22px);
        height: 195px;
    }

    @media (max-width: ${breakPoints.tablet}) {
        height: 242px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        width: calc(100% - 16px);
        height: 400px;
        background-image: url('${(props) => props.background}');
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
    }
`;

export const TextContainer = styled.div<{ positionText: string }>`
    padding: 83px 0 0 136px;
    align-items: center;
    flex-direction: column;

    @media (max-width: ${breakPoints.desktop}) {
        padding: 78px 0 70px 131px;
    }

    @media (max-width: ${breakPoints.sDesktop}) {
        padding: 54px 0 47px 101px;
    }

    @media (max-width: ${breakPoints.tablet}) {
        padding: 84px 0 70px 8vw;
    }

    @media (max-width: ${breakPoints.mobile}) {
        position: relative;
        height: fit-content;
        padding: 35px 0 0 30px;
        bottom: ${props => props.positionText};
    }
`;

export const TextWrap = styled.div<{ textColor: string}>`
    flex-direction: column;
    color: ${props => props.textColor};
    gap: 8px;
`;

export const SubTextMainBlock = styled.div`
    white-space: pre;
    ${FONTS.S};

    @media (max-width: ${breakPoints.sDesktop}) {
        ${FONTS.XS};
    }

    @media (max-width: ${breakPoints.tablet}) {
        ${FONTS.S};
    }

    @media (max-width: ${breakPoints.mobile}) {
        ${FONTS.XS};
    }
`;

export const TitleMainBlock = styled.div`
    ${FONTS.H2};

    @media (max-width: ${breakPoints.sDesktop}) {
        ${FONTS.H3};
    }

    @media (max-width: ${breakPoints.mobile}) {
        ${FONTS.H4};
    }
`;

export const ImgBlock = styled.div<{ ImgUrl: string }>`
    width: 679px;
    margin: 10px;
    background-image: url('${(props) => props.ImgUrl}');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    border-radius: ${BorderRadius.InnerBlockRadius};

    @media (max-width: ${breakPoints.sDesktop}) {
        width: 458px;
        margin: 16px;
        background-position: top;
    }

    @media (max-width: ${breakPoints.tablet}) {
        width: 357px;
        margin: 10px;
        background-position: center;
    }
`;

export const TripleCardWrapper = styled.div`
    width: calc(100% - 39px);
    height: 120px;
    gap: 39px;
    margin-top: 32px;

    @media (max-width: ${breakPoints.desktop}) {
        width: calc(100% - 35px);
        gap: 35px;
    }

    @media (max-width: ${breakPoints.sDesktop}) {
        width: calc(100% - 24px);
        height: 101px;
        margin-top: 22px;
        gap: 24px;
    }

    @media (max-width: ${breakPoints.tablet}) {
        gap: 16px;
        margin-top: 22px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        width: calc(100% - 16px);
        margin-top: 32px;
    }
`;

export const Slip = styled.div`
    align-items: center;
    flex-basis: calc((100% - 78px)/3);

    @media (max-width: ${breakPoints.desktop}) {
        flex-basis: calc((100% - 70px)/3);
    }

    @media (max-width: ${breakPoints.sDesktop}) {
        flex-basis: calc((100% - 48px)/3);
    }

    @media (max-width: ${breakPoints.tablet}) {
        flex-basis: calc((100% - 32px)/3);
    }

    @media (max-width: ${breakPoints.mobile}) {
        flex-basis: 100%;
    }
`;

export const SlipText = styled.div`
    ${FONTS.H4};
    white-space: pre;
    align-items: center;

    @media (max-width: ${breakPoints.sDesktop}) {
        ${FONTS.H5};
    }

    @media (max-width: ${breakPoints.tablet}) {
        min-height: 48px;
        white-space: break-spaces;
    }
`;

export const SlipContentWrapper = styled.div`
    width: 100%;
    padding: 31px 0 33px 47px;
    gap: 32px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    background-color: ${COLORS.white};

    @media (max-width: ${breakPoints.desktop}) {
        padding-left: 42px;
    }

    @media (max-width: ${breakPoints.sDesktop}) {
        gap: 16px;
        padding: 26px 0 27px 28px;
    }

    @media (max-width: ${breakPoints.tablet}) {
        justify-content: left;
        flex-wrap: nowrap;
        padding: 16px 7px 17px 2vw;
        align-items: center;
        gap: 20px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        padding: 12px 20px 18px 20px;
    }
`;

export const SlipIcon = styled.div<{ iconUrl: string }>`
    width: 56px;
    height: 56px;
    background-image: url('${(props) => props.iconUrl}');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;

    @media (min-width: ${BreakPointsMFirst.mobile}) and (max-width: ${breakPoints.tablet}) {
        width: 4vw;
        height: 4vw;
    }
`;
